import React from "react";
import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import "./styles/base.css";
import HashScroll from "./components/HashScroll";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import ContactPage from "./pages/ContactPage";
import ConstructionData from "./pages/ConstructionData";
import DataEngineeringServices from "./pages/DataEngineeringServices";
import DomainExpertisePage from "./pages/DomainExpertisePage";
import ESGSustainabilityData from "./pages/ESGSustainabilityData";
import EnergyData from "./pages/EnergyData";
import FinancialServicesLendingData from "./pages/FinancialServicesLendingData";
import IntegrationsPage from "./pages/IntegrationsPage";
import InsightsPage from "./pages/InsightsPage";
import LivingLineageMapArticle from "./pages/LivingLineageMapArticle";
import MigrationTestingPolarsArticle from "./pages/MigrationTestingPolarsArticle";
import PlatformAgnosticDataEngineeringArticle from "./pages/PlatformAgnosticDataEngineeringArticle";
import "./styles/responsive.css";

const App = () => {
  return (
    <Router>
      <div className="main">
        <HashScroll />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<DataEngineeringServices />} />
          <Route path="/services/data-engineering" element={<DataEngineeringServices />} />
          <Route path="/domain-expertise" element={<DomainExpertisePage />} />
          <Route
            path="/domain-expertise/financial-services"
            element={<FinancialServicesLendingData />}
          />
          <Route
            path="/domain-expertise/sustainability-reporting"
            element={<ESGSustainabilityData />}
          />
          <Route path="/domain-expertise/construction" element={<ConstructionData />} />
          <Route path="/domain-expertise/energy" element={<EnergyData />} />
          <Route path="/solutions" element={<Navigate to="/domain-expertise" replace />} />
          <Route
            path="/solutions/financial-services-lending-data"
            element={<Navigate to="/domain-expertise/financial-services" replace />}
          />
          <Route
            path="/solutions/esg-sustainability-data"
            element={<Navigate to="/domain-expertise/sustainability-reporting" replace />}
          />
          <Route path="/integrations" element={<IntegrationsPage />} />
          <Route path="/blog" element={<InsightsPage />} />
          <Route path="/blog/living-data-lineage-map" element={<LivingLineageMapArticle />} />
          <Route
            path="/blog/testing-data-migrations-python-polars"
            element={<MigrationTestingPolarsArticle />}
          />
          <Route
            path="/blog/platform-agnostic-data-engineering"
            element={<PlatformAgnosticDataEngineeringArticle />}
          />
          <Route path="/insights" element={<Navigate to="/blog" replace />} />
          <Route
            path="/insights/living-data-lineage-map"
            element={<Navigate to="/blog/living-data-lineage-map" replace />}
          />
          <Route path="/case-studies" element={<Navigate to="/blog" replace />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
